export enum ThirdPartyCallBack {
  SessionExpire = "SessionExpire",
  BuySell = "BuySell",
  DownloadReport = "DownloadReport",
  Pledge = "Pledge",
  Edis = "Edis",
}

export enum LoginSource {
  IPHONE = "iphone",
  ANDROID = "android-phone",
  TX3 = "X",
  SALES = "sales",
}

export const EMTReportCallBack = (
  loginSrc: LoginSource,
  type: ThirdPartyCallBack,
  data?: any,
) => {
  const windowX: any = window;

  const callBack: any = {};
  switch (type) {
    case ThirdPartyCallBack.SessionExpire:
      callBack[LoginSource.IPHONE] = () => {
        if (windowX?.webkit?.messageHandlers?.onSessionExpired) {
          windowX.webkit.messageHandlers.onSessionExpired.postMessage({
            status: "true",
          });
        }
      };
      callBack[LoginSource.ANDROID] = () => {
        if (windowX?.EDREVAMPJsBridge?.onSessionExpired)
          windowX.EDREVAMPJsBridge.onSessionExpired();
      };
      break;
    case ThirdPartyCallBack.BuySell:
      callBack[LoginSource.IPHONE] = () => {
        if (windowX?.webkit?.messageHandlers?.onBuySell)
          windowX.webkit.messageHandlers.onBuySell.postMessage({
            data,
          });
      };
      callBack[LoginSource.ANDROID] = () => {
        if (windowX?.EDREVAMPJsBridge?.onBuySell)
          windowX.EDREVAMPJsBridge.onBuySell(JSON.stringify(data));
      };
      break;
    case ThirdPartyCallBack.DownloadReport:
      callBack[LoginSource.IPHONE] = () => {
        if (windowX?.webkit?.messageHandlers?.downloadReport)
          windowX.webkit.messageHandlers.downloadReport.postMessage({
            method: data?.method,
            fileFormat: data?.fileFormat,
            reportType: data?.reportType,
            params: data?.params,
          });
      };
      callBack[LoginSource.ANDROID] = () => {
        if (windowX?.EDREVAMPJsBridge?.downloadReport)
          windowX.EDREVAMPJsBridge.downloadReport(JSON.stringify(data));
      };
      break;
    case ThirdPartyCallBack.Edis:
      callBack[LoginSource.IPHONE] = () => {
        if (windowX?.webkit?.messageHandlers?.onAuthorization)
          windowX.webkit.messageHandlers.onAuthorization.postMessage({
            sts: data.sts,
            holdings: data.holdings,
          });
      };
      callBack[LoginSource.ANDROID] = () => {
        if (windowX?.EDISJsBridge?.onAuthorization)
          windowX.EDISJsBridge.onAuthorization(
            JSON.stringify({
              sts: data.status,
              holdings: data.holdings,
            }),
          );
      };
      break;
    default:
      console.log("did not found this case " + type);
  }
  if (callBack[loginSrc]) callBack[loginSrc]();
  else console.log("did not found any call back on " + loginSrc);
};
export const triggerDownloadReportCallback = (
  method: string,
  fileFormat: string,
  reportType: string,
  params: any,
  loginSource: string,
) => {
  const data = {
    method: method,
    fileFormat: fileFormat,
    reportType: reportType,
    params: params,
  };
  EMTReportCallBack(
    loginSource as LoginSource,
    ThirdPartyCallBack.DownloadReport,
    data,
  );
};
export const isLoginSourceEMT = (loginSource: string, reverse?: boolean) => {
  return (
    loginSource &&
    (loginSource === LoginSource.IPHONE || loginSource === LoginSource.ANDROID)
  );
};
